export const token = `${process.env.REACT_APP_TOKEN}`;
export const apiBaseUrl = `${process.env.REACT_APP_API_BASE_URL}`;
export const SSO_BUTTON_LABEL = process.env.REACT_APP_SSO_BUTTON_LABEL;
export const SSO_URL = process.env.REACT_APP_SSO_URL;
export const SSO_AVAILABLE = process.env.REACT_APP_SSO_AVAILABLE === 'true';
export const SSO_APP_URL = process.env.REACT_APP_SSO_APP_URL;
export const ITEMS_PER_PAGE = 25;
export const errorMessage = "Something went wrong";
export const successMessage = "Action completed successfully";

export const SELECTED_JOURNAL_IDS_KEY = 'selectedJournalsIds';

export const notificationsTime = 3000;

export const defaultColor = "#4285F4";

export const signalCheckSignals = [
  { label: 'Fake affiliation names', value: 'signalCheck.fakeAffiliationNames' },
  { label: 'Fake names or e-mail addresses', value: 'signalCheck.fakeNamesOrEmailAddresses' },
  { label: 'Fake e-mail domains', value: 'signalCheck.fakeEmailDomains' },
  { label: 'Disposable e-mail domains', value: 'signalCheck.disposableEmailDomains' },
  { label: 'Suspect articles', value: 'signalCheck.suspectArticles' },
  { label: 'Manuscripts offered for sale', value: 'signalCheck.manuscriptsOfferedForSale' },
  { label: 'Metadata suspects', value: 'signalCheck.metadataSuspects' }
];

export const conductCheckSignals = [
  { label: 'Bad actors', value: 'conductCheck.badActors' },
];

export const referenceSignals = [
  { label: 'DOI analysis', value: 'doiAnalysis' },
  { label: 'Retraction Watch', value: 'retractionWatch' },
  { label: 'Crossref checks', value: 'crossrefChecks' },
  { label: 'Context checks', value: 'contextChecks' },
];

export const textSignals = [
  { label: 'Tortured phrases', value: 'torturedPhrases' },
  { label: 'Suspect phrases', value: 'suspectPhrases' },
  { label: 'GenAI response', value: 'genAIResponse' },
  // { label: 'Geppetto', value: 'geppetto' },
  { label: 'Nonsensical text', value: 'geppetto' },
];

export const regExpPassword =
    /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[-#!$'�??%^@&*()_+|~=`{}\[\]'<>?,.\/]).{8,}$/;
